import React, { forwardRef, useLayoutEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { StyledScrollArea, StyledScrollAreaContent } from './styled';
import { scrollbarWidth } from '../../utils/helpers';
import useCombinedRefs from '../../hooks/useCombinedRefs';

const ScrollArea = forwardRef(({ children, heightModifiers, onScroll }, ref) => {

  const innerRef  = useRef(null);
  const combinedRef = useCombinedRefs(ref, innerRef);

  const scrollBarSize = useMemo(() => heightModifiers?.isCalc ? scrollbarWidth() : 0, [heightModifiers]);

  useLayoutEffect(() => {
    if (heightModifiers.isCalc) {
      const { top = 0 } = combinedRef.current?.getBoundingClientRect();
      combinedRef.current.style.height = `calc(100vh - ${top + heightModifiers?.offset}px)`;
    }
  }, [combinedRef, heightModifiers]);

  return (
    <StyledScrollArea>
      <StyledScrollAreaContent
        ref={combinedRef}
        scrollBarSize={scrollBarSize}
        maxHeight={heightModifiers?.maxHeight}
        onScroll={onScroll}
      >
        {children}
      </StyledScrollAreaContent>
    </StyledScrollArea>
  );
});

ScrollArea.propTypes = {
  children: PropTypes.node,
  heightModifiers: PropTypes.shape({
    isCalc: PropTypes.bool,
    offset: PropTypes.number,
    maxHeight: PropTypes.number
  })
};

ScrollArea.defaultProps = {
  children: '',
  heightModifiers: {
    isCalc: false,
    offset: 0
  }
};

export default React.memo(ScrollArea);
